import { ChangeDetectorRef, Component, Input, OnInit, Renderer2 } from '@angular/core';
import { ManualAwardsService } from '../../../services/manual-awards.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GamesService } from '../../../services/games.service';
import { AwardsHistoryListComponent } from '../view-history/awards-history-list/awards-history-list.component';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { DatePipe } from '@angular/common';
import { AwardedPopupComponent } from '../awarded-popup/awarded-popup.component';
import { GridOptions } from 'ag-grid-community';
import { cloneDeep } from 'lodash';
import { CxoneLoginsAssignToolComponent } from 'src/app/reusables/assign-tool/cxone-logins-assign-tool/cxone-logins-assign-tool.component';
import { DialogService } from 'primeng/dynamicdialog';
import { CvAwardHistoryModalComponent } from '../cv-award-history-modal/cv-award-history-modal.component';
import { CvCxLoginAssignToolOptions, LoginAssignTool } from 'src/app/reusables/assign-tool/cxone-logins-assign-tool/cxone-logins-assign-tool.model';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { ToastrManager } from '@niceltd/sol/toastr';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { PointStorePermissionService } from 'src/app/gamification/marketplace/admin/services/point-store-permission.service';
import { AliasPageName } from 'src/app/gamification/cv-marketplace-admin/models/gamification-pages.model';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { AdminValidationService } from '../../../services/admin-validation.service';

@Component({
  selector: 'cv-awards-landing',
  templateUrl: './awards-landing.component.html',
  styleUrls: ['./awards-landing.component.scss'],
  providers: [DialogService]
})
export class AwardsLandingComponent implements OnInit {
  public localizationDic: Map<string, string> = new Map();
  gf: any;
  maf: any;
  dateFormat = CVAngularDateFormat;
  isCopy: boolean = true;

  //details popup
  loading: boolean
  isVisible: boolean
  loadingHistory: boolean


  //modified 
  _old: null | any
  item: {} | any
  isReferencing: boolean

  //For group list
  columns = [];
  newDataArray = [];

  //Enums
  Views = {
    Main: 0,
    AddEdit: 1
  }

  //Controller variables
  customBadgeCreatorVisible = false;
  view = this.Views.Main;
  badgeIDs = [];
  selectedBadgeID = 0;
  manualAwards: any[] = [];
  assignToolVisible = false;
  awardToolVisible = false;
  awardedIsVisible = false;
  awardToList = [];
  coinValue = 100;
  folders = [];
  searchfolders: string[] = [];
  cxoneSearchFolders = [];
  filter = {
    folder: "",
    searchTerm: ""
  };
  giveInProgress = false;
  tab = "awards";
  manualAward: any = {};
  selectedAward: any = {};
  defaultCategorySelection = {};
  tooltipText = "";

  @Input() isCxone: boolean;

  constructor(
    private manualAwardsService: ManualAwardsService,
    private gamesService: GamesService,
    private localizationService: CVLocalizationService,
    private cdr: ChangeDetectorRef,
    private dialogSrc: DialogService,
    private toastrManager: ToastrManager,
    private cvNumberLocalizePipe: CvNumberLocalizePipe,
    private pointStorePermissionService: PointStorePermissionService,
    private cvConfigurationService: CvConfigurationService,
    private adminValidationService: AdminValidationService,
  ) {
    this._old = {};
    this.item = {
      AssignedRoles: []
  };
  }

  async ngOnInit(): Promise<void> {
    await this.loadPermissionList();
    this.gf = this.gamesService.data;
    this.maf = this.manualAwardsService.data;
    this.item = {};
    this.isCopy = true;
    this.isReferencing = false;
    this.loading = true
    this.adminValidationService.isLoadingSavingProcess = true;
    this.isVisible = false
    this.loadingHistory = false
    this.manualAwards = [];
    await this.initAsync();
  }

  async initAsync() {
    this.localizationDic = await this.localizationService.GetSection("Manual_Awards");
    await Promise.all([
      this.localizationService.GetLocalText("Common", "All", "All").then(val => this.searchfolders.push(val)),
      this.localizationService.GetLocalText("Common", "All", "All").then(val => this.filter.folder = val)
    ]);
    this.defaultCategorySelection = {
      value: this.getLocalizationString('All', 'All'),
      name: this.getLocalizationString('All', 'All')
    }
    this.loadManualAwards();
  }

  setupFilter() {
    this.filter = {
      folder: "(" + this.getLocalizationString('All', 'All') + ")",
      searchTerm: ""
    };
  }

  loadModal() {
    this.isVisible = true;
  }

  loadManualAwards() {
    // this.manualAwardsService.loadManualAwards(true).then((result) => {
    this.manualAwardsService.loadManualAwardsAsync(true).then((result) => {
      if (result != null && result.data != null) {
        if (result.data.ManualAwards != null)
          this.manualAwards = result.data.ManualAwards;
        if (result.data.ImageIDs != null)
          this.badgeIDs = result.data.ImageIDs;
        if (result.data.Folders != null) {
          this.searchfolders = cloneDeep(result.data.Folders);
          if(!this.isCxone) {
            this.searchfolders.unshift(this.getLocalizationString('All', 'All'));
          } else {
            this.cxoneSearchFolders = this.searchfolders.map(folder => {
              return { value: folder, name: folder };
            });
            this.cxoneSearchFolders.unshift(this.defaultCategorySelection)
          }
          this.folders = result.data.Folders;

          this.folders.forEach((item) => {
            this.maf.awardsFolderStates[item] = true;
          })
        }
        this.coinValue = result.data.CoinValue;
      }

         this.loading = false;

    }).finally(() => {
      this.adminValidationService.isLoadingSavingProcess = false;

    });
  };

  onNewFolder(folderName: string) {
      this.insertInSortedOrder(this.folders, folderName, (a, b) => a.localeCompare(b));
      this.maf.awardsFolderStates[folderName] = true;
      this.insertInSortedOrder(this.searchfolders, folderName, (a, b) => a.localeCompare(b));
      this.insertInSortedOrder(this.cxoneSearchFolders, { value: folderName, name: folderName }, (a, b) => a.name.localeCompare(b.name));
  }

  insertInSortedOrder<T>(array: T[], element: T, compareFn: (a: T, b: T) => number) {
      const index = array.findIndex(item => compareFn(item, element) > 0);
      if (index === -1) {
          array.push(element);
      } else {
          array.splice(index, 0, element);
      }
  }

  isEmptyFilterCase = (itm: { Key: string }) => {
    const shouldFilterFolder = this.filter.folder !== this.getLocalizationString('All', 'All');
    // Short circuit empty cases
    // there is no search applied and folder is filtered by "All"
    const noSearchApplied = this.filter.searchTerm === "" && !shouldFilterFolder;
    // we are filtering by folder and the current item is not the folder that we need
    const isNotFolderSelected = shouldFilterFolder && itm.Key !== this.filter.folder;
    // we don't have data in manualAwards
    const isAwardEmpty = this.manualAwards == null;
    return {
      isEmptyCase: noSearchApplied || isNotFolderSelected || isAwardEmpty,
      // this is the value that we should return in the filter (true or false)
      returnValue: noSearchApplied || !isNotFolderSelected || isAwardEmpty,
    };
  }

  hasAwardWithSearchTerm = (folderItems: { Name: string }[])=> {
    return folderItems.some(folder => folder.Name.toLowerCase().includes(this.filter.searchTerm.toLowerCase()));
  }

  hasMatchesAnyItemName = ({ Value: folderItems }) => {
    return this.hasAwardWithSearchTerm(folderItems);
  }

  filterFolders = (itm: { Key: string }): boolean => {
    const emptyCase = this.isEmptyFilterCase(itm);
    if (emptyCase.isEmptyCase){
      return emptyCase.returnValue;
    }
    // Items found, need to check item names too
    const items = this.manualAwards.filter((i) => i.Key === itm.Key);
    const matchesAnyItemName = items.some(this.hasMatchesAnyItemName);
    return matchesAnyItemName; // Return whether any items match the search term
  };

  filterManualAwards(itm: any) {
    if (this.filter.searchTerm == "") {
      return true;
    }
    var matchesItemName = itm.Name.toLowerCase().indexOf(this.filter.searchTerm.toLowerCase()) > -1;

    return matchesItemName;
  }


  showOptionsMenu(item: any) {
    item.showOptions = true;
  }

  WrapSortValuesByString = (key: string) => {
    return (a: { [key: string]: string }, b: { [key: string]: string }) => {
      const keyA = a[key]?.toLowerCase();
      const keyB = b[key]?.toLowerCase();
  
      // Special function to check if a character is a special character
      const isSpecialChar = (char: string) => /[^a-z0-9]/i.test(char);
      const isNumber = (char: string) => /[0-9]/.test(char);
  
      if (isSpecialChar(keyA[0]) && !isSpecialChar(keyB[0])) return -1;
      if (!isSpecialChar(keyA[0]) && isSpecialChar(keyB[0])) return 1;
      if (isNumber(keyA[0]) && !isNumber(keyB[0])) return -1;
      if (!isNumber(keyA[0]) && isNumber(keyB[0])) return 1;
  
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    }
  }
  
  sortAwards = () => {
    this.manualAwards.sort(this.WrapSortValuesByString('Key'));
    this.manualAwards.forEach(element => {
      element.Value?.sort(this.WrapSortValuesByString('Name'));
    });
  }

  changeView = (info: any) => {
    this._old = info.old;
    this.item = info.item;
    let lastView = this.view;
    this.view = info.view;

    if (!info.isCancelled) {
      if (this.Views.AddEdit === lastView && Object.keys(this._old).length !== 0) {
        this.checkFolders();
      }
      this.awardCopy(lastView, info.item, info.old);
    } else {
      //delete copy
      const matchItem = this.manualAwards.find(f => f.Key === info.old.Folder);

      if (matchItem) {
        matchItem.Value = matchItem.Value.filter((value, index, self) => {
          return value.RuleID !== 0;
        });
      }
      this._old = {};
    }
    this.sortAwards();
  };

    checkFolders() {
    // only for Edit
    if (this._old.Folder !== this.item.Folder) {
      if (this._old.RuleID === this.item.RuleID) {
        this.handleFolderChangeForEdit();
      } else {
        this.handleFolderChangeForCopy();
      }
    }
  }

  getCombinedLabel(): string {
    const localizedGamesCount = this.cvNumberLocalizePipe.transform(this.awardsCount);
    const label = this.awardsCount === 1 ? this.getLocalizationString('Award', 'award') : this.getLocalizationString('Awards', 'awards');
    return `${localizedGamesCount} ${label}`;
  }
  
  handleFolderChangeForEdit() {
    // Remove the award from the old folder
    const oldFolder = this.manualAwards.find(f => f.Key === this._old.Folder);
    if (oldFolder) {
      oldFolder.Value = oldFolder.Value.filter(value => value.RuleID !== this.item.RuleID);
      // Remove the old folder if it's empty
      this.removeEmptyFolder(oldFolder, this._old.Folder);
    }
  
    // Add the award to the new folder
    this.addAwardToNewFolder();
  }
  
  handleFolderChangeForCopy() {
    // Specific logic for copying
    if (!this.cxoneSearchFolders.find(f => f.value === this.item.Folder)) {
      this.maf.awardsFolderStates[this.item.Folder] = true;
      this.insertAlphabeticallyByName(this.cxoneSearchFolders, { value: this.item.Folder, name: this.item.Folder }, 'value');
      this.insertAlphabetically(this.searchfolders, this.item.Folder);
    }
  }
  
  removeEmptyFolder(folder, folderKey) {
    if (folder.Value.length === 0) {
      this.removeFolder(folderKey);
      this.folders = this.folders.filter(f => f !== folderKey);
    }
  }
  
  addAwardToNewFolder() {
    if (!this.folders.includes(this.item.Folder)) {
      this.manualAwards = [...this.manualAwards, { Key: this.item.Folder, Value: [this.item] }];
      this.folders = [...this.folders, this.item.Folder];
    } else {
      const newFolder = this.manualAwards.find(f => f.Key === this.item.Folder);
      if (newFolder) {
        this.insertAlphabeticallyByName(newFolder.Value, this.item, 'Name');
      }
    }
  }

  insertAlphabeticallyByName<T>(array: T[], element: T, property: string) {
    const index = array.findIndex(item => item[property].localeCompare(element[property]) > 0);
    if (index === -1) {
        array.push(element);
    } else {
        array.splice(index, 0, element);
    }
  }

  insertAlphabetically(array: string[], element: string) {
    const index = array.findIndex(item => item.localeCompare(element) > 0);
    if (index === -1) {
      array.push(element);
    } else {
      array.splice(index, 0, element);
    }
  }
  
  onReference(item: any) {
    this.item = {};
    this._old = {};
    this.item = item;
    this.isReferencing = true;
  }

  displayFolderContent(folderKey: any) {
    this.maf.awardsFolderStates[folderKey] = !this.maf.awardsFolderStates[folderKey];
  }

  removeAwardFromFrontend = (item) => {
    var folderMatch = this.manualAwards.filter((f) => { return f.Key == item.Folder });
    if (folderMatch != null && folderMatch.length > 0) {
      var idx = folderMatch[0].Value.indexOf(item);
      if (idx > -1) {
        var numItemsInFolder = folderMatch[0].Value.length;
        folderMatch[0].Value.splice(idx, 1);

        if (numItemsInFolder <= 1) {
          this.removeFolder(item.Folder);
          this.folders = this.folders.filter(f => f !== item.Folder);
        }
      }
    }
  }

  removeFolder(folderName) {
    var folderIdx = -1;
    for (var i = 0; i < this.manualAwards.length; i++) {
      if (this.manualAwards[i].Key == folderName)
        folderIdx = i;
    }
    if (folderIdx > -1)
      this.manualAwards.splice(folderIdx, 1);

    //Remove folder from filter
    let folderFilterIdx = -1;
    if (!this.isCxone) {
      for (var i = 0; i < this.searchfolders.length; i++) {
        if (this.searchfolders[i] == folderName)
          folderFilterIdx = i;
      }
    } else {
      for (var i = 0; i < this.cxoneSearchFolders.length; i++) {
        if (this.cxoneSearchFolders[i].value == folderName)
          folderFilterIdx = i;
      }
    }
    if (folderFilterIdx > -1) {
      if (!this.isCxone) {
        this.searchfolders.splice(folderFilterIdx, 1);
      } else {
        this.cxoneSearchFolders.splice(folderFilterIdx, 1);
      }
    }
  };

  New() {
    this.isCopy = false;
    this._old = {};
    this.item = this.manualAwardsService.makeNewManualAward();
  }

  ResetToOriginal() {
    if (this.isReferencing) {
      this.item = {};
      this.isReferencing = false;
      return;
    }

    if (!this.isCopy && (JSON.stringify(this._old) !== JSON.stringify(this.item))) {
      this._old = { ...this.item }; // Clones the object this.item into this._old
    }
  }

  addManualAward = async () => {
    const hasCreatePermission: boolean = await this.pointStorePermissionService.validatePermission({
      name: this.pointStorePermissionService.getCreatePermissionName(),
      pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.AwardsTab),
      newCXoneModalVersion: true
    }, !this.cvConfigurationService.isCxOne);
    if (!hasCreatePermission) {
      return;
    }
    this.New();
    this.view = this.Views.AddEdit;
  };

  handleIsCopyChange(isCopy: boolean) {
    this.isCopy = isCopy;
  }

  updateOldValue(newValue: {}): void {
    this._old = newValue;
  }

  awardCopy(lastView, item, old) {

    if (lastView === this.Views.AddEdit) { //restoring the original data. Removing copy
      const matchItem = this.manualAwards.find(f => f.Key === old.Folder);
      if (matchItem) {
        matchItem.Value = matchItem.Value.filter((value, index, self) => {
          return value.RuleID !== 0 && self.findIndex(v => v.RuleID === value.RuleID) === index;
        });
      }
      this._old = {};
    }

    if (item.RuleID === 0) {   //creating a copy
      delete old.showOptions;
      const matchItem = this.manualAwards.find(f => f.Key === this.item.Folder);

      if (matchItem) {
        matchItem.Value.push(old);
      }
    }
  }

  closeAwardPopup() {
    this.awardToolVisible = false;
    this.manualAward = null;
  }

  async openAwardPopup(item: any) {
    if (!this.isCxone) {
      this.manualAward = item;
      this.awardToolVisible = true;
    } else {
      const hasCreatePermission: boolean = await this.pointStorePermissionService.validatePermission({
        name: this.pointStorePermissionService.getViewPermissionName(),
        pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.AwardsTab),
        newCXoneModalVersion: true
      }, !this.cvConfigurationService.isCxOne);
      if (!hasCreatePermission) {
        return;
      }

      this.manualAward = item;
      const options: CvCxLoginAssignToolOptions = {
        getLogins: this.executeGetLogins,
        submitLogins: (logins: LoginAssignTool[]) => this.manualAwardsService.giveManualAwards(this.manualAward.RuleID, logins).then((response:any) => {          
            const messageToaster = response.TotalBadgesGiven === 1 ? this.getLocalizationString("Award_Given_Successfully", "Award given successfully.") : this.getLocalizationString("Awards_Given_Successfully", "Awards given successfully.");
            this.toastrManager.showToaster('success', messageToaster);
        }) as Promise<ApiResponse<any>>,
        headerTitle: this.getLocalizationString('Select_Recipients', 'Select Recipients'),
        saveLabel: this.getLocalizationString('Give_Award', 'Give Award'),
        cancelLabel: this.getLocalizationString('Cancel', 'Cancel'),
      }
      this.dialogSrc.open(CxoneLoginsAssignToolComponent, {
        width: "775px",
        height: "calc(100% - 50px)",
        baseZIndex: 10000,
        styleClass: 'cx-one-ui awards-recipients-modal btn-bg-is-white',
        data: {
          options
        }
      });
    }
  }

  executeGetLogins:() => Promise<ApiResponse<LoginAssignTool[]>>  = () => this.manualAwardsService.getManualAwardLogins(this.manualAward.RuleID) as Promise<ApiResponse<LoginAssignTool[]>>;

  showAwardedPopup(item: any) {
    this.selectedAward = item;
    this.awardedIsVisible = true;
  }

  hideAwardedPopup() {
    this.selectedAward = {};
    this.awardedIsVisible = false;
  }

  closeAwardHistoryPopup() {
    this.isVisible = false;
  }

  getLocalizationString(key: string, defaultValue: string) {
    if (this.localizationDic) {
      if (this.localizationDic.has(key)) {
        return this.localizationDic.get(key);
      }
    }
    return defaultValue;
  }

  get awardsCount() {
    return this.loading ? 0 : this.manualAwards
      .filter(this.filterFolders)
      .reduce((counter, folder) => {
          return counter + folder.Value.filter(this.filterManualAwards.bind(this)).length;
      }, 0);
  }

  get showEmptyState() {
    return this.loading || this.manualAwards.filter(this.filterFolders).length > 0;
  }

  checkTextTruncation(tooltip: string, selector: HTMLSpanElement) {
    if(selector){
      this.tooltipText = (selector.offsetWidth < selector.scrollWidth || selector.offsetHeight < selector.scrollHeight) ? tooltip : '';
      this.cdr.detectChanges();
    } else {
      this.tooltipText = '';
    }
  }

  clearTooltipText() {
    this.tooltipText = '';
  }

  async loadPermissionList() {
    if (!this.cvConfigurationService.isCxOne) {
      return;
    }
    await this.pointStorePermissionService.loadPermission(
      this.pointStorePermissionService.pageNameFilter(AliasPageName.AwardsTab)
    );
  }

  hasPermissionAwards(permission: string): boolean {
    return this.pointStorePermissionService.checkPermission(permission,
      this.pointStorePermissionService.pageNameFilter(AliasPageName.AwardsTab)
    );
  }

  openAwardHistoryModal() {
    this.dialogSrc.open(CvAwardHistoryModalComponent, {
      width: "966px",
      height: "523px",
      baseZIndex: 10000,
      styleClass: 'cx-one-ui award-history-modal btn-bg-is-white',
    });
  }
}
